export const commonStyles = {
  linkOverride: {
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },
  mainPagePadding: {
    padding: '20px 60px',
  },
};
